import LoadingElement from "@/Components/Loading/LoadingElement";
import { Environment, QueryRenderer } from "react-relay";
import { graphql } from "relay-runtime";
import { relayAuthEnvironment } from "@/RelayEnvironment";
import ManagerDispositionMainView from "@/Domains/DispositionManagement/Views/ManagerDispositionMainView";
import { ManagerDispositionMainViewQueryRendererViewerQuery } from "@/Domains/DispositionManagement/QueryRenderer/__generated__/ManagerDispositionMainViewQueryRendererViewerQuery.graphql";
import LoginExpiredModal from "@/Components/LoginExpiredModal/LoginExpiredModal";
import React, {useEffect, useState} from "react";
import {useAppSelector} from "@/Redux/Redux";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";
import TranslationGate from "@/Utils/TranslationGate";
import {useSelector} from "react-redux";
import {selectLocale} from "@/Redux/App/AppReducer";

interface ManagerComponentProps {
    isLoggedIn: boolean;
    width: number;
}

export default function ManagerDispositionMainViewQueryRenderer(
    props: ManagerComponentProps,
) {
    const { initialized, dispositionStartdate, dispositionEnddate } =
        useAppSelector((state) => state.disposition);

    const [tmpStartdate, setTmpStartdate] = useState<string | null>(null);
    const [tmpEnddate, setTmpEnddate] = useState<string | null>(null);
    const { prefixLoaded, addTranslations } = useTranslation();
    const language = useSelector(selectLocale);

    if (tmpStartdate != dispositionStartdate && tmpEnddate != dispositionEnddate && initialized) {
        setTmpStartdate(dispositionStartdate);
        setTmpEnddate(dispositionEnddate);
    }

    return (
        <>
            <QueryRenderer<ManagerDispositionMainViewQueryRendererViewerQuery>
                //@ts-ignore
                environment={relayAuthEnvironment() as Environment}
                query={graphql`
                    query ManagerDispositionMainViewQueryRendererViewerQuery($startdate: String, $enddate: String, $lang: String!, $prefixes: [String]) {
                        viewer {
                            userId                       
                        }
                        holidayList(startdate: $startdate, enddate: $enddate) {
                            holidays {
                                date
                                occasion                        
                            }                        
                        }
                        translationList(lang: $lang, prefixes: $prefixes) {
                                translations {
                                    component
                                    text
                                }
                            }
                        }
                `}
                cacheConfig={{ force: true }}
                variables={{
                    startdate: tmpStartdate,
                    enddate: tmpEnddate,
                    lang: language?.locale ?? language,
                    prefixes: ["CRW6.disposition", "CRW6.bookingLine", "CRW6.vehicleLine", "CRW6.popover"]
                }}
                render={(result) => {
                    if (result.error) {
                        return <LoginExpiredModal />;
                    }

                    if (!result.props?.viewer) {
                        return <LoadingElement />;
                    }

                    return (
                        <TranslationGate translationList={result.props?.translationList} prefix={"disposition"}>
                            <ManagerDispositionMainView
                                width={props.width}
                                viewData={result.props?.viewer}
                                holidays={result.props?.holidayList?.holidays}
                            />
                        </TranslationGate>
                    );
                }}
            />
        </>
    );
}
